module.exports = __webpack_public_path__ + "img/ic_check.6f4f5b58.svg";